class BigImageOverlay {
  domElement: HTMLElement;
  imageElement: HTMLImageElement;

  constructor() {
  }

  init() {
    this.domElement = document.getElementById('bigImageOverlay');
    this.imageElement = this.domElement.querySelector('img');
    this.domElement.querySelector('button').addEventListener('click', () => this.hide())
  }

  show(url: string) {
    this.domElement.style.display = 'initial';
    this.imageElement.src = url;
  }

  hide() {
    this.domElement.style.display = 'none';
    this.imageElement.src = '';
  }
}

export default new BigImageOverlay();
